import React, { useContext, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import "./Cancel_Reason_Modal.css";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllCancelReason } from "../../../../features/master/masterSlice";

function Cancel_Reason_Modal({
  setCancelReasonId,
  cancelReasonId,
  reason,
  setError,
  cancelReasonName,
  setCancelReasonName,
  ...props
}) {
  const { show, onHide, modal_title, selectReason, setSelctedReason } = props;

  // const reasons = [
  //   "Product price has reduced",
  //   "Wrong contact number entered",
  //   "Ordered by mistake",
  //   "Incorrect product size/colour/type ordered",
  //   "Product price has reduced",
  //   "Wrong contact number entered",
  //   "Ordered by mistake",
  //   "Incorrect product size/colour/type ordered",
  // ]

  const dispatch = useDispatch();
  // const reasons = useSelector((state) => state.master.cancelReasons);

  useEffect(() => {
    dispatch(getAllCancelReason());
  }, [dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className="Cancel_Reason_Modal Modal-holder"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {modal_title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="select_reason">
          <Form>
            {reason?.map((value, index) => (
              <>
                {" "}
                <Form.Check
                  key={index}
                  label={value?.name}
                  value={value?.id}
                  name="order_cancel_reason_id"
                  type="radio"
                  className="mini-text"
                  checked={cancelReasonId === value?.id}
                  onChange={(e) => {
                    setCancelReasonId(Number(e.target.value));
                    setCancelReasonName(value?.name);
                    setError("");
                    onHide();
                  }}
                />
              </>
            ))}
          </Form>

          {/* <div className="btn_holder">
            <Green_Btn btn_name="Save" onClick={() => { onHide() }} />
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Cancel_Reason_Modal;
